import Vue from 'vue';

const state = {
  sessionData: {},
  isLogin: false
};

const mutations = {
  'SET_SESSION' (state, data) {
    state.sessionData = data;
  },
  'SET_LOGIN_STATUS' (state, data) {
    state.isLogin = data;
  }
};

const actions = {
  login: ({ commit }, formData) => {
    return Vue.http.post('webstore/login', formData)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.session) {
          window.localStorage.setItem(['userId'],[data.id_user]);
          window.localStorage.setItem(['sessionToken'],[data.session]);
          window.localStorage.setItem(['userName'], [data.name_user]);
          commit('SET_SESSION', data);
          commit('SET_LOGIN_STATUS', true);
        }
        return data;
      });
  },
  setLogin: ({ commit }, info) => {
    window.localStorage.setItem(['userId'],[info.id_user]);
    window.localStorage.setItem(['sessionToken'],[info.session]);
    window.localStorage.setItem(['userName'], [info.name_user]);
    commit('SET_SESSION', info);
    commit('SET_LOGIN_STATUS', true);
  },

  logout: ({ commit }) => {
    return Vue.http.post('webstore/logout', {})
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        window.localStorage.clear();
        commit('SET_LOGIN_STATUS', false);
        return data;
      });
  },
  resetAllStore: ({ commit, dispatch }) => {
    commit('SET_LOGIN_STATUS', false);
    commit('SET_SESSION', {});
  },
  checkLogin: ({ commit }) => {
    if (window.localStorage.getItem(['sessionToken'])) {
      commit('SET_LOGIN_STATUS', true);
    } else {
      commit('SET_LOGIN_STATUS', false);
    }
  },
  passwordReset: ({ commit, dispatch}, text) => {
    return Vue.http.post('user/reset/pw', {
      email: text
    })
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.message === "this email is not used.") {
          alert("指定されたメールアドレスは使用されていません。");
        } else if (data.isSuccess) {
          alert("指定されたメールアドレスにメールを送信いたしました。");
          dispatch('hideLightBox');
        } else {
          alert("正常に処理が終了しませんでした。Globeeまでお問い合わせください。");
        }
      }).catch(() => {
        alert("正常に処理が終了しませんでした。Globeeまでお問い合わせください。");
      });
  }
};

const getters = {
  sessionData: state => {
    return state.sessionData;
  },
  isLogin: state => {
    return state.isLogin;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth.js